;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.showAll = (function () {
    const initialize = function () {
      const $showAll = $('a.show-all')
      if ($showAll) {
        const $container = $('.' + $showAll.attr('data-container'))
        if ($container) {
          $('a.show-all').on('click', function () {
            $container.find('.hidden').removeClass('hidden')
            return false
          })
        }
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.showAll.initialize()
  })
}(jQuery, window))
